import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet';

import '../../Layout/Main.scss';
import DownloadButton from '../../Buttons/DownloadButton';
import Block from '../../Layout/Block';
import usePageTracking from '../../../hooks/usePageTracking';

const ImmobilienPreise = (): ReactElement => {
  const lastChanged = '26.05.2020'; // UPDATE WHEN CHANGING PAGE

  usePageTracking('Immobilienpreise Wien 2020 - Neubauprojekte in Wien');

  return (
    <>
      <Helmet>
        <title>Immobilienpreise Wien 2020 - Neubauprojekte in Wien</title>

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Immobilienpreise Wien 2020 - Neubauprojekte in Wien"
        />
        <meta
          property="og:url"
          content="https://www.neubauprojekte.wien/immobilienpreise-wien-2020/"
        />
        <meta
          property="article:published_time"
          content="2020-06-20T10:09:21+00:00"
        />
        <meta
          property="article:modified_time"
          content="2020-08-16T12:03:45+00:00"
        />
      </Helmet>
      <div className="mainContent page">
        <h1>Immobilienpreise Wien 2020</h1>
        <div className="separator" />

        <div className="p-grid">
          <div className="lg:col-6">
            <h2>Eigentumswohungen Erstbezug</h2>
            <Block>Weitere Informationen folgen in Kürze!</Block>
            <div style={{ width: 'fit-content' }}>
              <DownloadButton
                text="Preise Eigentumswohnungen 2020 PDF"
                link="/pdf/immobilienpreise-2020-eigentumswohnungen-wien.pdf"
              />
            </div>

            <h3>Preise pro m² Wohnnutzfläche in Euro</h3>
            <img
              width="100%"
              src="/immobilienpreise/immobilienpreis-eigentumswohnungen-wien-1.png"
              alt="immobilienpreis-eigentumswohnungen-wien-1.png"
            />

            <Block>Preise Eigennutzer netto</Block>
            <Block>
              Quelle: Erhebung von Angebotspreisen durch neubauprojekte.wien
            </Block>
          </div>
          <div className="lg:col-6">
            <h2>Mietwohnungen Erstbezug</h2>
            <Block>Weitere Informationen folgen in Kürze!</Block>

            <div style={{ width: 'fit-content' }}>
              <DownloadButton
                text="Preise Mietwohnungen 2020 PDF"
                link="/pdf/immobilienpreise-2020-mietwohnungen-wien.pdf"
              />
            </div>

            <h3>Preise pro m² Wohnnutzfläche in Euro</h3>
            <img
              width="100%"
              src="/immobilienpreise/immobilienpreis-mietwohnungen-wien.png"
              alt="immobilienpreis-mietwohnungen-wien.png"
            />

            <Block>Preise Eigennutzer netto</Block>
            <Block>
              Quelle: Erhebung von Angebotspreisen durch neubauprojekte.wien
            </Block>
          </div>
          <div>zuletzt aktualisiert am: {lastChanged}</div>
        </div>
      </div>
    </>
  );
};
export default ImmobilienPreise;
